import { Component, inject, signal, OnInit, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';

import { ReceiptView } from '../receipt/receipt-view';
import { AuthService } from '../../../services/auth';
import { PageTitleService } from '../../../services/page-title';

/**
 * Standalone payment-success page — the natural target for a gateway `paymentSuccessUrl`
 * redirect (and a route we can push to after an inline verify). Renders the shared ReceiptView
 * for the :paymentId, with Print / Download ready, plus a Done action.
 */
@Component({
  selector: 'app-payment-success',
  standalone: true,
  imports: [CommonModule, CardModule, ButtonModule, ReceiptView],
  templateUrl: './payment-success.html',
  styleUrls: ['./payment-success.css'],
})
export class PaymentSuccess implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private auth = inject(AuthService);
  private platformId = inject(PLATFORM_ID);
  readonly pageTitle = inject(PageTitleService).title;

  paymentId = signal<number | null>(null);
  /** Optional — if the redirect carries ?memberId=, offer "Collect for another". */
  memberId = signal<number | null>(null);

  ngOnInit() {
    if (!isPlatformBrowser(this.platformId)) return;
    const id = Number(this.route.snapshot.paramMap.get('paymentId')) || 0;
    this.paymentId.set(id > 0 ? id : null);
    const mid = Number(this.route.snapshot.queryParamMap.get('memberId')) || 0;
    this.memberId.set(mid > 0 ? mid : null);
  }

  done() {
    this.router.navigate([this.auth.isAdmin() ? '/payments/list' : '/partner-dashboard']);
  }

  findAnother() {
    this.router.navigate(['/payments/receipts']);
  }

  /** Open the member's Certificate of Insurance (only offered when the redirect carried ?memberId=). */
  viewCertificate() {
    const id = this.memberId();
    if (id) this.router.navigate(['/policies/certificate', id]);
  }
}
